import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { Url } from '@wix/da-url';
import { BiData, SendNoteClickBiEvent } from '@wix/da-bi/pkg/events';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import MailIcon from '@wix/da-ds/pkg/Icons/24x24/Mail';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedInAndVerified } from '@wix/da-shared-react/pkg/utils/hooks/useRestrictToLoggedInAndVerified';

interface Props {
  className?: string;
  profileOwner: PapiUser;
}

export const NoteButton: FC<Props> = ({ className, profileOwner }) => {
  const { restrictToLoggedInAndVerified } = useRestrictToLoggedInAndVerified();
  const { t } = useTranslation();
  const handleClick = restrictToLoggedInAndVerified(
    ReferralType.NOTE,
    'notes',
    () => window.location.assign(Url.userNoteLink(profileOwner.username))
  );
  return (
    <IconButton
      size="medium"
      title={t(`navigation.subnavigation.sendNote`)}
      className={className}
      tooltipText={t(`navigation.subnavigation.sendNote`)}
      icon={MailIcon}
      onClick={handleClick}
      aria-label={t('navigation.subnavigation.sendNote')}
      biData={BiData<SendNoteClickBiEvent>({
        evid: 273,
        friend_id: profileOwner.useridUuid,
        recipientid: profileOwner.useridUuid,
        typeid: ResourceType.USER,
        itemid: profileOwner.userId,
      })}
    />
  );
};
NoteButton.displayName = 'NoteButton';

export default NoteButton;
